module.exports = "/img/icon-livechat.svg?40409f6cf61c8d21d6ccba0a7f8135ef";